import { render } from "./ripple-ink.vue?vue&type=template&id=baf9dbee&lang=pug"
import script from "./ripple-ink.vue?vue&type=script&lang=js"
export * from "./ripple-ink.vue?vue&type=script&lang=js"
script.render = render

export default script